import styled from 'styled-components';
import { SmallCapsHeadline, Paragraph, SubHeadline } from 'ggApp/shared/common/Typography';

export const Wrap = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 16px;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        display: block;
    `};
`;

export const Item = styled.div`
    margin-bottom: 16px;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        padding-bottom: 24px;
    `};
`;

export const Label = styled(SmallCapsHeadline)`
    margin-bottom: 4px;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin-bottom: 2px;
    `};
`;

export const SectionTitle = styled(SubHeadline)`
    margin-bottom: 16px;
`;

export const Text = styled(Paragraph)`
    color: ${({ theme }) => theme.colors['Level 5']};
`;